/**
 * PhonesProvider
 * HOC for wrapping the provided component with PhonesProvider
 */

import React from 'react'

import PhonesProvider from './phones-provider'

export default function withPhones (WrappedComponent) {
  return function PhonesProviderHOC(props) {
    return (
      <PhonesProvider>
        <WrappedComponent {...props} />
      </PhonesProvider>
    )
  }
}
